import * as tslib_1 from "tslib";
import { ApiLoadingService } from "./api-loading.service";
import { ApiCallService } from "./api-call.service";
import { HttpClient } from "@angular/common/http";
import { LocaleService } from "../seo/locale.service";
var BlocksService = /** @class */ (function () {
    function BlocksService(apiLoadingService, apiCallService, httpClient, localeService) {
        this.apiLoadingService = apiLoadingService;
        this.apiCallService = apiCallService;
        this.httpClient = httpClient;
        this.localeService = localeService;
    }
    BlocksService.prototype.getBlocks = function (category, fetchLocalData) {
        if (fetchLocalData === void 0) { fetchLocalData = false; }
        return fetchLocalData
            ? this.fetchLocalData("../../../assets/data/blocks/" + category + ".json")
            : this.apiCallService.get("/block_categories/" + category + "/blocks");
    };
    BlocksService.prototype.fetchLocalData = function (path) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get("../../../" + path).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BlocksService.prototype.resolve = function (route, state) {
        var _this = this;
        var promise;
        var categories = route.data["blocks_categories"];
        var localeDataPath = route.data["localeDataPath"];
        if (localeDataPath) {
            var path = localeDataPath;
            if (route.data["hasMultipleTranslations"]) {
                path = path + "_" + this.localeService.getCurrentLocale() + ".json";
            }
            else {
                path = path + ".json";
            }
            return this.fetchLocalData(path);
        }
        if (categories.length > 1) {
            var all_1 = [];
            categories.forEach(function (category) {
                all_1.push(_this.getBlocks(category));
            });
            promise = Promise.all(all_1);
        }
        else {
            promise = this.getBlocks(categories[0]);
        }
        this.apiLoadingService.startLoading(promise);
        return promise;
    };
    return BlocksService;
}());
export { BlocksService };
